import React, { useEffect, useState} from "react";
import Header from "../components/Header";
import { Link , useLocation ,useParams, useNavigate } from "react-router-dom";
import Nodata from "../components/NoData";
import { BsFillPenFill, BsFillLockFill, BsFillTrashFill } from "react-icons/bs";
import {alert, confirm} from "../components/MegConfirmAlert";
import Accordion from 'react-bootstrap/Accordion';
import { useTranslation } from 'react-i18next';
import ProdList from "../components/ProdList";
import { useAxios } from "../services/useAxios";
import Modal from 'react-bootstrap/Modal';
import ProductQnAWrite from "./ProductQnAWrite"

export default function ProductQnA() {
    const { t } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();  

    let {id} = useParams();
    const userInfo = JSON.parse(localStorage.getItem("user")).data;
    const lang = localStorage.getItem("language") || "ko";
    const [request] = useAxios();
    const [data, setData] = useState({});
    const [dataList, setDataList] = useState([]);
    const [replyList, setReplyist] = useState([]);
    const [page, setPage] = useState(0);
    const [isOpen, setOpen] = useState(false);
    const [isQnAOpen, setQnaOpen] = useState(false);

    const [qnaInfo, setQnaInfo] = useState({});

    const ConfirmLogin = async () => {
        const userData = localStorage.getItem("user");
        if (userData === null) {            
            navigate('/LogIn', {
                state: { from: location },
            })            
        }
        setQnaInfo({})
        setQnaOpen(true)
    }

    const fn_delNtt = async (obj) => {
        const result = await confirm(t(`Message.inqry_info_page_remove_confirm`), {okText : t(`Message.common_yes`) , cancelText :t(`Message.common_no`)});
        if(result){
            const response = await request.post("/app/mypage/procInqryNttRemoveAPI", {                
                nttSn : obj.nttSn,
                bbsSn : 2
                });
            if(response.data.resultCode === 200){  
                await alert("삭제되었습니다",{okButtonStyle : 'secondary', okText: t(`Message.common_ok`)});        
                window.location.reload();              
            }else{
                alert(response.data.resultMessage)
            }
        }
    }

    const fetchData3 = async (obj) => {
        
        
        const response = await request.post("/app/goods/getGoodsInqryReplyListAPI", {                
            firstNttSn : obj.nttSn
            });
        if(response.data.resultCode === 200){
            console.log(response.data.result);
            setReplyist((prevData) => [...prevData, ...response.data.result.goodsInqryReplyList]);
        }     
           
        
    }

    const fetchData = async () => {

        const response = await request.post("/app/goods/getGoodsDetailAPI", {
            nationSeCode : lang,
            goodsSn : id
        });
        if(response.data.resultCode === 200){
            console.log(response.data.result);
            setData(response.data.result);
        }            
    };

    const fetchData2 = async (pageIndex) => {
        
        const response = await request.post("/app/goods/getGoodsNttListAPI", {            
            bbsSn : 2,
            aditfield1 :id,
            replyShowAt : 'Y',
            aditfield5 : 'INQ001',
            pageIndex : pageIndex

        });
        if(response.data.resultCode === 200){     
            console.log(response.data.result)                               
            setDataList((prevData) => [...prevData, ...response.data.result.resultList]);
            response.data.result.resultList.forEach(function (value, index) {
                fetchData3(value)
            })
        }            
    };

    useEffect(() => {
        fetchData();
      }, []);

      useEffect(() => {    
        if(page > 0){
            fetchData2(page);    
        }
      }, [page]);

      
  const handleObserver = (entries) => {
    const target = entries[0];
    if (target.isIntersecting ) {
        setPage((prevPage) => prevPage + 1);
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(handleObserver, {
      threshold: 0, //  Intersection Observer의 옵션, 0일 때는 교차점이 한 번만 발생해도 실행, 1은 모든 영역이 교차해야 콜백 함수가 실행.
    });
    // 최하단 요소를 관찰 대상으로 지정함
    const observerTarget = document.getElementById("observer");
    // 관찰 시작
    if (observerTarget) {
      observer.observe(observerTarget);
    }
  }, []);

    return(

        <div>
            <div className="backGround bgBlue"></div>
            <div className="headFixed backGround bgBlue">
            <Header type="cart" pageTitle={data.goodsInfoVO && data.goodsInfoVO.goodsNm}/>
                <div className="tabArea">
                    <Link to={"/ProductDetail/"+id} className="tabBtn">{t(`Message.goods_detail_screen_tab_title1`)}</Link>
                    <Link to={"/ProductBuyInfo/"+id} className="tabBtn">{t(`Message.goods_detail_screen_tab_title2`)}</Link>
                    <Link to={"/ProductReview/"+id} className="tabBtn">{t(`Message.goods_detail_screen_tab_title3`)} {data.goodsReviewCnt && data.goodsReviewCnt}</Link> 
                    <Link className="tabBtn active">{t(`Message.goods_detail_screen_tab_title4`)} {data.goodsInqryCnt && data.goodsInqryCnt}</Link>
                </div>
            </div>


            <div className="hdTabContWr">
                <div className="totalWr">
                    <p>{t(`Message.goods_inqry_list_goods_inqry`)} <span>{t(`Message.goods_inqry_list_tot_cnt` , {resultCnt : data.goodsInqryCnt && data.goodsInqryCnt})}</span></p>
                    <button 
                        type="button" 
                        className="greenB cFFF btn24"
                        onClick={ConfirmLogin}
                    >
                        <BsFillPenFill /> {t(`Message.goods_inqry_list_inquire_reg`)}
                    </button>
                </div>

                {dataList && dataList.length === 0?(
                <div className="floatCenter">
                    <Nodata text={t(`Message.goods_inqry_list_empty_msg`)}/>
                </div> 
                 ):(
                    <>
                

                <div className="prodQnaWr">
                    <Accordion className="prodQnaAccordion">
                        {dataList && dataList.map((obj, index) => (
                        <Accordion.Item eventKey={index} key={index}>
                            <Accordion.Header >
                                <div className="pqaHd">
                                    <p className={"qnaTag "+(obj.replyCnt > 0?"fin":"wait")}>{obj.replyCnt > 0? t(`Message.goods_inqry_list_answer_complate`):t(`Message.goods_inqry_list_answer_wait`)}</p>
                                    <div className="dfColG6 w100per">
                                        <div className="pqdfsb">
                                            <div className="optionWr">
                                                <p className="option">{obj.frstRegisterId}</p>
                                                <p className="option">{obj.frstRegistPnttm}</p>
                                            </div>
                                            {(obj.writerDplctCode === userInfo.userId) && (obj.replyCnt <= 0) ?(
                                            <div className="dfceG6">
                                                <div 
                                                
                                                    className="btn2424 pen"
                                                    onClick={(e) => {
                                                        e.preventDefault(); 
                                                        e.stopPropagation(); 
                                                        setQnaInfo(obj)
                                                        setQnaOpen(true)
                                                    }}
                                                >
                                                    <BsFillPenFill />
                                                </div>
                                                
                                                <div 
                                                    
                                                    className="btn2424 del"
                                                    onClick={(e) => {
                                                        e.preventDefault(); 
                                                        e.stopPropagation(); 
                                                        fn_delNtt(obj)                   
                                                    }}
                                                >
                                                    <BsFillTrashFill />
                                                </div>
                                            </div>
                                            ):null}
                                        </div>
                                        <p className="qnaTit">{obj.othbcAt === 'Y'?obj.nttSj: t(`Message.goods_inqry_list_secret_msg`)}</p>
                                    </div>
                                </div>
                            </Accordion.Header>
                            {obj.othbcAt === 'Y'?(
                            <Accordion.Body>
                               
                                    <>
                                <div className="qnaCont">{obj.nttCn}</div>
                                {replyList && replyList.filter((el) => el.firstNttSn === obj.nttSn).map((obj2, index2) => (
                                <div className="answerWr" key={index2}>
                                    <p className="greenTxt">A.</p>
                                    <p className="answer">{obj2.nttCn}</p>
                                </div>
                                 ))}  
                                 </>
                                
                            </Accordion.Body>
                            ):null}
                        </Accordion.Item>
                        ))}  
                        
                        
                        
                        
                    </Accordion>
                </div>
                </>
                )}
                <div id="observer" style={{ height: "10px" }}></div>

                <div className="bottomBtnWr">
                    <button 
                        type="button" 
                        className="btn48 cFFF orgB"
                        onClick={(e) => {
                            e.preventDefault(); 
                            e.stopPropagation(); 
                            setOpen(true);
                        }}>
                        {t(`Message.bottom_navigation_bar_order_btn`)}
                    </button>
                </div>

                <ProdList id={id} prodOpen={isOpen} setProdOpen={setOpen}></ProdList>
            </div>

            <Modal
                className="btModal"
                show={isQnAOpen}
                onHide={setQnaOpen}
                fullscreen={true}
                aria-labelledby="contained-modal-title-vcenter"
                centered                
                keyboard={false}
                >
                <ProductQnAWrite modal={true}  goodsSn={id} closeFn={setQnaOpen} dataInfo={qnaInfo} ></ProductQnAWrite>
            </Modal>
        </div>
    );
};